import { compose } from "redux";

import { StaticTextPage } from "../src/staticTextPage/StaticTextPage";
import withAuthentication from "../src/withAuthentication";
// @ts-ignore
import { permissions, PUBLIC } from "../src/routes";

export default compose(withAuthentication(permissions[PUBLIC]))(
  // @ts-ignore
  StaticTextPage,
);
